@if (store.info(); as info) {
  <div class="environment" [innerHtml]="info"></div>
}
